import React, { ReactNode, useEffect, useReducer } from 'react';

import { Provider as ProfessionalSignUpProvider } from 'src/modules/app/hooks/useProfessionalSignUp';
import {
  SignUpAction,
  SignUpData,
} from 'src/modules/signUp/components/Professional/types';
import { useEphemeralEmail } from 'src/shared/hooks';

interface ProviderProps {
  children: ReactNode;
}

const userReducer = (
  previousState: SignUpData,
  action: SignUpAction,
): SignUpData => {
  switch (action.type) {
    case 'UPDATE_USER':
    case 'UPDATE_PROFILE':
    case 'UPDATE_PARTIAL_PROFILE':
    case 'UPDATE_EXTERNAL_PROFILE':
      return { ...previousState, ...action.payload };
    default:
      return previousState;
  }
};

const ProfessionalSignUp = ({ children }: ProviderProps) => {
  const { setEmail: setEphemeralEmail } = useEphemeralEmail();

  const [user, userDispatch] = useReducer(userReducer, {});

  useEffect(() => {
    if ('email' in user) setEphemeralEmail(user.email);
  }, [setEphemeralEmail, user]);

  const contextValue = { user, userDispatch };

  return (
    <ProfessionalSignUpProvider value={contextValue}>
      {children}
    </ProfessionalSignUpProvider>
  );
};

export { ProfessionalSignUp };
